
export default {
  contactUsTitle: "اتصل بنا",
  contactUsDesc: "تواصل مع فريقنا لأي استفسارات أو دعم",
  name: "الاسم",
  contactEmail: "البريد الإلكتروني",
  message: "الرسالة",
  yourName: "اسمك",
  yourEmail: "بريدك الإلكتروني",
  howCanWeHelp: "كيف يمكننا المساعدة؟",
  send: "إرسال",
  sending: "جاري الإرسال...",
  downloadCampaignGuide: "تحميل دليل الحملة",
  downloading: "جاري التحميل...",
  
  // Contact Page Additional
  getInTouch: "تواصل معنا",
  email: "البريد الإلكتروني",
  location: "الموقع",
  sendMessage: "أرسل لنا رسالة",
  readyToStart: "هل أنت مستعد لبدء رحلتك في الإعلان الرقمي؟ دعنا نناقش أهدافك وننشئ شيئًا رائعًا معًا.",
  messageSentTitle: "تم إرسال الرسالة بنجاح",
  messageSentDesc: "سنعود إليك في أقرب وقت ممكن.",
  messageErrorTitle: "خطأ في إرسال الرسالة",
  messageErrorDesc: "يرجى المحاولة مرة أخرى لاحقًا.",
} as const;
